import { IJxtModalConfig, JxtModalSizeEnum } from './types';

export const JxtModalConfig: IJxtModalConfig = {
  size: {
    [JxtModalSizeEnum.S]: 'sm:max-w-modal-sm',
    [JxtModalSizeEnum.M]: 'sm:max-w-modal-md',
    [JxtModalSizeEnum.L]: 'sm:max-w-modal-lg h-[80vh]',
  },
};
